import TriggerResetPasswordForm from './TriggerResetPasswordForm';
export default TriggerResetPasswordForm;
